// extracted by mini-css-extract-plugin
export default {"formBlock":"Login_formBlock__5AsgB","divider":"Login_divider__rH1mt","buttonBlock":"Login_buttonBlock__CpR8C"};